<template v-if="contextProduct && contextPricing">
  <div class="">
    <div class="">
      <div class="d-flex justify-content-center">
        <h5 class="mt-3 mb-0">
          Mennyiségi kedvezmény részletező
        </h5>
      </div>
      <div class="btn-close float-end" style="margin-top: -24px; cursor: pointer; font-size: 16px;" @click.self="$one?.context.closePlugin"></div>
    </div>
    <hr>
    <div class="row">
      <table class="qty-table mt-2">
        <thead>
          <tr><th colspan="2">{{ $t("text.discountHead") }}</th></tr>
        </thead>
        <tbody>
          <tr v-for="(data, idx) in discountData" :key="idx">
            <template v-if="data.amount">
              <td class="col-9">{{ data.quantity }} {{ contextUnit }} egységenként</td>
              <td class="col-3">{{ $n(parseFloat(data.amount)/100 || 0, "percent") }}</td>
            </template>
          </tr>
          <template v-if="discountData">
            <tr v-for="i in 3-discountData.length" :key="i"><td colspan="2">&nbsp;</td></tr>
          </template>
        </tbody>
      </table>
    </div>
    <hr class="mt-4 mb-3">
    <div class="row">
      <table class="qty-table mt-2">
        <thead>
          <tr>
            <th class="col-5">{{ $t("text.discountBreakdown") }}</th>
            <th class="col-2">{{ $t("text.discountPricePerUnit", { unit: contextUnit }) }}</th>
            <th class="col-5">{{ $t("text.discountPriceTotal") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pline, idx) in configurableProducts" :key="idx">
            <template v-if="pline.type === 'ADD'">
              <td>{{ pline.configurableProduct.main.quantity.value }} {{ contextUnit }}</td>
              <td>{{ $n(getProductLinePrice(pline), "currency") }}</td>
              <td>{{ $n(getProductLinePrice(pline) * pline.configurableProduct.main.quantity.value, "currency") }}</td>
            </template>
          </tr>
          <tr v-for="i in (3-getBodyAddedProducts().length)" :key="i"><td colspan="3">&nbsp;</td></tr>
        </tbody>
        <tfoot>
          <tr><th colspan="3">{{ $t("text.totalDiscount") }}</th></tr>
          <tr>
            <td>{{ bodyTotalQuantity }} {{ contextUnit }}</td>
            <td>-</td>
            <td>{{ $n(bodyTotalPrice, "currency") }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="row">
      <div class="d-flex justify-content-center pt-5">
        <AddToCartComponent v-if="contextProduct" :product="contextProduct" :onSubmit="send" v-model:quantity="rawContextQuantity" />
      </div>
    </div>
  </div> 
</template>

<style>
table.qty-table {
  text-align: center;
  width: 90%;
}

table.qty-table, table.qty-table td, table.qty-table th {
  border: 2px solid lightslategray;
  border-collapse: collapse;
  padding: 2px;
  margin: auto;
}
hr {
  border: 2px solid darkgrey !important;
  opacity: 1 !important;
  margin-bottom: 0.5rem !important;
  margin-left: -16px !important;
  width: 380px;
}
</style>

<script>
import { ref } from "vue";
import AddToCartComponent from "./AddToCart.vue";

const _contextQuantity = ref(1);

// eslint-disable-next-line no-unused-vars
function debugLog(...args) {
  console.log("[Sztkm-Vue]", ...args);
  console.log(args["error"]);
}

export default {
  name: "QuantityDiscountComponent",
  components: { AddToCartComponent },
  data() {
    return {
      configurableProducts: [],
      contextPricing: null,
      contextProduct: null,
      contextQuantity: _contextQuantity,
      cartContextQuantity: this.getCartContextQuantity(),
      discountData: this.getDiscountData(),
      /** @type {import("../plugins/fetising").Fetising} */
      $fetising: null,
      // /** @type {import('@one-commerce/sdk-core').ShopSdk} */
      // $one: null,
    };
  },
  computed: {
    contextUnit() {
      // return this.contextProduct?.measurementUnits.contentUnitCode.toLowerCase();
      return this.contextProduct?.measurementUnits.orderUnitDescription.toLowerCase();
      // return "egység"
    },
    rawContextQuantity() {
      return _contextQuantity;
    },
    bodyTotalPrice() {
      let total = 0;
      for (const pline of this.configurableProducts) {
        if (pline.type != "ADD") continue;
        total += this.getProductLinePrice(pline) * pline.configurableProduct.main.quantity.value;
      }
      return total;
    },
    bodyTotalQuantity() {
      let total = 0;
      for (const pline of this.configurableProducts) {
        if (pline.type != "ADD") continue;
        total += pline.configurableProduct.main.quantity.value;
      }
      return total;
    }
  },
  methods: {
    getProductLinePrice(pline) {
      let price = parseFloat(pline.configurableProduct.main.priceOverride?.pricePerContentUnit.toFixed(2));
      if (!price) return parseFloat(this.contextPricing.price);
      return price * this.contextProduct.measurementUnits.packingQuantity
    },
    getBodyAddedProducts() {
      const list = []
      for (let product of this.configurableProducts) {
        if (product.type == "ADD") {
          list.push(product);
        }
      }
      return list;
    },
    buildRequestBody() {
      if (!this.contextPricing || !this.contextProduct || isNaN(this.contextQuantity)) return;
      let qty = this.contextQuantity + this.cartContextQuantity;
      let discountDatas = [...this.discountData].reverse();
      this.configurableProducts.length = 0;

      for (const cartProduct of this.getCartContextProducts()) {
        this.configurableProducts.push({ type: "REMOVE", productLine: cartProduct.productLineId })
      }

      while (discountDatas.length > 0) {
        const discountData = discountDatas.shift();

        if (!discountData.amount) continue;
        
        const q1 = qty - (qty % discountData.quantity);
        
        if (q1 > 0) {
          this.configurableProducts.push(
            this.createAddConfigurableProductsIntegrationApiCommand(this.contextProduct, q1, this.contextPricing, discountData)
          )
        }

        qty -= q1;
      }

      if (qty > 0) {
        this.configurableProducts.push(
          this.createAddConfigurableProductsIntegrationApiCommand(this.contextProduct, qty, this.contextPricing, null)
        )
      }

      this.getBodyAddedProducts()
    },
    async send() {
      if (this.configurableProducts) {
        return fetch(process.env.VUE_APP_API_URL + "/api/index.php/add-to-cart-popup", {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            token: this.$one.token,
            customerId: this.$one.account.client.id,

            cartId: this.$one.context.cartId,
            rawOperations: this.configurableProducts
          })
        })
        .then(response => response.json())
        .then(json => {
          if (json.status === false) {
            return Promise.reject(json)
          }
          return json
        })
        .then(json => debugLog("ADD2CART-OK", json))
        .then(() => this.$one.context.closePlugin())
        .catch(json => {
          debugLog("ADD2CART-NOK", json.error.code, json.error.message)
        });
      } else {
        return null;
      }
    },
    getCartContextProducts() {
      let products = [];

      for (const entry of this.$one.cart.currentCart.products) {
        if (entry[1].id !== this.$one.context.productId) continue;
        products.push(entry[1]);
      }
      
      return products;
    },
    getCartContextQuantity() {
      let quantity = 0;

      for (const product of this.getCartContextProducts()) {
        for (const shipment of product.shipments) {
          quantity += shipment.numberOfProducts
        }
      }
      
      return quantity;
    },
    getDiscountData() {
      let ddata;
      if (this.$fetising.isVE()) {
        ddata = this.$one.context.meta?.quantityDiscount.VE;
      } else if (this.$fetising.isVF()) {
        ddata = this.$one.context.meta?.quantityDiscount.VF;
      } else {
        ddata = this.$one.context.meta?.quantityDiscount.VF;
      }

      if (this.contextProduct) {
        const packingQuantity = this.contextProduct.measurementUnits.packingQuantity;
        for (const data of ddata) {
          data.quantity = data.quantity / packingQuantity;
        }
      }

      return ddata;
    },

    createAddConfigurableProductsIntegrationApiCommand(product, quantity, pricing, rules) {
      return {
        type: "ADD",
        configurableProduct: {
          main: {
            productId: product.id,
            quantity: {
              // type: "CONTENT_QUANTITY",
              type: "ORDER_QUANTITY",
              value: quantity,
            },
            allowQuantityChange: false, // (pricing && rules) ? false : true,
            priceOverride: {
              pricePerContentUnit: pricing.price/product.measurementUnits.packingQuantity * ( rules ? 1-rules.amount/100 : 1 )
            }
          },
          children: []
        }
      }
    },
  },
  mounted() {
    this.$one.catalog.fetchProduct(this.$one.context.productId).then(product => this.contextProduct = product);
    this.$one.catalog.getProductPrice(this.$one.context.productId, false).then(pricing => this.contextPricing = pricing);

    /*
    this.$fetising.sztkmcall("sztkm", "getProductQuantity", [ this.$one.context.productId ])
      .then((result) => parseInt(result.quantity))
      .then(quantity => this.contextQuantity = quantity);
    */
    
    this.contextQuantity = this.$one.context.productAmount
  },
  watch: {
    "$one.token": function() {
    },
    contextProduct() { this.discountData = this.getDiscountData(); this.buildRequestBody(); },
    contextPricing() { this.buildRequestBody(); },
    contextQuantity() { this.buildRequestBody(); },
  },
}

</script>